/* eslint-disable prettier/prettier */
// Lib
import { Action, handleActions } from 'redux-actions';

// Actions
import {
  ClearSlides,
  DeleteSlides,
  SetSlidesLoading,
  UpdateSlides,
} from '@actions/user';

interface Slide {
  _id: string;
  [key: string]: unknown;
}

interface SlidesState {
  slides: Slide[];
  deletedSlides: Slide[];
  isLoading: boolean;
}

type SetSlidesLoadingAction = Action<boolean>;
type UpdateSlidesAction = Action<Slide[]>;
type DeleteSlidesAction = Action<Slide[]>;

export const initialState: SlidesState = {
  slides: [],
  deletedSlides: [],
  isLoading: false,
};

export default handleActions<SlidesState, boolean | Slide[]>(
  {
    [SetSlidesLoading.toString()]: (
      state: SlidesState,
      { payload }: SetSlidesLoadingAction,
    ): SlidesState => ({
      ...state,
      isLoading: payload,
    }),
    [UpdateSlides.toString()]: (
      state: SlidesState,
      { payload }: UpdateSlidesAction,
    ): SlidesState => ({
      ...state,
      slides: payload as Slide[],
    }),
    [DeleteSlides.toString()]: (
      state: SlidesState,
      { payload }: DeleteSlidesAction,
    ): SlidesState => ({
      ...state,
      deletedSlides: [...state.deletedSlides, ...(payload as Slide[])],
    }),
    [ClearSlides.toString()]: (state: SlidesState): SlidesState => ({
      ...state,
      slides: initialState.slides,
      deletedSlides: initialState.deletedSlides,
    }),
  },
  initialState,
);
